import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ProfileSelectorComponent as ProfileSelectorUIComponent } from '@com-delta-idp/mnx-capability-profile-selector-ui';
import { ProfileSelectorSupportComponent } from './profile-selector-support.component';

@Component({
  selector: 'idp-profile-selector',
  standalone: true,
  templateUrl: './profile-selector.component.html',
  styleUrls: ['./profile-selector.component.scss'],
  imports: [CommonModule, ProfileSelectorUIComponent]
})
export class ProfileSelectorComponent
  extends ProfileSelectorSupportComponent
  implements OnInit, AfterViewInit
{
  @Output() toggle = new EventEmitter<boolean>();
  @Output() showSwitching = new EventEmitter<boolean>();
  @ViewChild('loginPickerRedirectForm')
  loginPickerRedirectForm!: ElementRef<HTMLFormElement>;

  @ViewChild('profileModal', { static: true }) profileModal!: ElementRef;
  @ViewChild(ProfileSelectorUIComponent) child!: ProfileSelectorUIComponent;

  ngOnInit(): void {
    this.setModalProperties();
    this.getDataForStandAlonePage();
  }

  ngAfterViewInit(): void {
    this.modalContainerFocus();
    this.getElementRef();
  }

  getElementRef(): void {
    this.getElementRefHelper(this.loginPickerRedirectForm);
  }

  setModalProperties(): void {
    this.checkAlertAdvisorContainer();
    this.modalContainerFocus();
    this.getInnerWidth();
    this.setModalPosition();
  }

  getDataForStandAlonePage(): void {
    if (this.profileSelectorFacadeService.fromProfileStandAlone$.value) {
      this.fromStandAlonePage = true;
      this.profileSelectorFacadeService.enableProfileSelector(
        this.fromStandAlonePage
      );
      this.defaultSelectAccount(
        (this.profileSelectorAdapterHelperService.firstName = ''),
        'P',
        0
      );
      this.setModalProperties();
      this.assignRefreshURL();
    } else {
      const headerTop = document.querySelector('.header__top') as HTMLElement;
      if (headerTop) {
        this.profileSelectorFacadeService.enableProfileSelector(false);
      }
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.getInnerWidth();
    this.setModalPosition();
    this.checkAlertAdvisorContainer();
  }

  @HostListener('document:keydown', ['$event'])
  handleTabKeyWInModel(event: KeyboardEvent): void {
    if (this.fromStandAlonePage) return;
    this.handleTabKey(
      event,
      '#profile-selector-smart',
      'input,button,select,textarea,a,[tabindex]:not([tabindex="-1"])'
    );
  }

  handleTabKey(e: KeyboardEvent, modelId: string, tagsList: string): void {
    if (e.key === 'Tab') {
      const focusable = this.elementRef.nativeElement
        .querySelector(modelId)
        .querySelectorAll(tagsList);
      if (focusable.length) {
        this.focusTab(focusable, e);
      }
    }
  }

  onClose(): void {
    this.toggle.emit();
    this.renderer.removeClass(document.body, 'modal-open');
  }

  setModalPosition(): void {
    const totalHeight = this.calculateTotalHeight();
    const top = this.getModalTop(totalHeight);
    this.renderer.setStyle(this.profileModal.nativeElement, 'top', top);
    this.setStyleForStandalone(this.profileModal.nativeElement, totalHeight);
  }

  private calculateTotalHeight(): number {
    const alertHeight =
      document.querySelector('.alert-advisory-main-container')?.scrollHeight ??
      0;
    const headerHeight = this.getHeaderHeight();
    return alertHeight + headerHeight;
  }

  private getHeaderHeight(): number {
    const navHeight = document.querySelector('.navbar')?.scrollHeight ?? 0;
    const headerTopHeight =
      document.querySelector('.header__top')?.scrollHeight ?? 0;
    return navHeight || headerTopHeight;
  }

  private getModalTop(totalHeight: number): string {
    return this.innerWidth <= 767 ? '0px' : `${totalHeight}px`;
  }
}
